/* SKINGRAPHICA redesign, Academy reference pages. Search, filters, A to Z, contents rail, timeline progress, back to top */
(function () {
  var root = document.querySelector('[data-ac]');
  if (!root) return;
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  var items = $$('[data-ac-i]');
  var groups = $$('[data-ac-grp]');
  var chips = $$('[data-ac-f]');
  var q = root.querySelector('[data-ac-q]');
  var clear = root.querySelector('[data-ac-clear]');
  var count = root.querySelector('[data-ac-n]');
  var empty = root.querySelector('[data-ac-empty]');
  var noun = root.getAttribute('data-ac-noun') || 'entries';
  var noun1 = root.getAttribute('data-ac-noun1') || 'entry';
  var rail = $$('[data-ac-rail] a');
  var lifeRows = $$('[data-ac-life]');
  var top = root.querySelector('[data-ac-top]');
  var filter = 'all', term = '';

  var DIA = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(DIA, ''); }
  items.forEach(function (it) { it._s = norm(it.getAttribute('data-ac-s') || it.textContent); });

  function apply() {
    var n = 0, words = norm(term).split(' ').filter(Boolean);
    items.forEach(function (it) {
      var okF = filter === 'all' || it.getAttribute('data-ac-g') === filter;
      var okQ = words.every(function (w) { return it._s.indexOf(w) > -1; });
      it.hidden = !(okF && okQ);
      if (!it.hidden) n++;
    });
    groups.forEach(function (g) {
      var key = g.getAttribute('data-ac-grp');
      g.hidden = !items.some(function (it) { return !it.hidden && it.getAttribute('data-ac-g') === key; });
    });
    rail.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('data-for'));
      if (a.parentNode) a.parentNode.hidden = !t || t.hidden;
    });
    lifeRows.forEach(function (r) {
      var t = document.getElementById(r.getAttribute('data-for'));
      r.classList.toggle('dim', !t || t.hidden);
    });
    if (count) count.textContent = n === items.length ? items.length + ' ' + noun : n + ' of ' + items.length + ' ' + (items.length === 1 ? noun1 : noun);
    if (empty) empty.hidden = n > 0;
    if (clear) clear.hidden = !term;
    /* chips report how many each filter would show for the current search */
    chips.forEach(function (c) {
      var f = c.getAttribute('data-ac-f');
      var k = items.filter(function (it) { return (f === 'all' || it.getAttribute('data-ac-g') === f) && words.every(function (w) { return it._s.indexOf(w) > -1; }); }).length;
      var sp = c.querySelector('span'); if (sp) sp.textContent = k;
      c.disabled = k === 0 && f !== filter;
    });
    spy();
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      filter = c.getAttribute('data-ac-f');
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      apply();
      var list = root.querySelector('[data-ac-list]');
      if (list && list.getBoundingClientRect().top < 0) list.scrollIntoView({ block: 'start' });
    });
  });
  var tmr;
  if (q) q.addEventListener('input', function () { clearTimeout(tmr); tmr = setTimeout(function () { term = q.value; apply(); }, 120); });
  if (clear) clear.addEventListener('click', function () { q.value = ''; term = ''; apply(); q.focus(); });
  $$('[data-ac-reset]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (q) q.value = ''; term = ''; filter = 'all';
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-ac-f') === 'all' ? 'true' : 'false'); });
      apply();
    });
  });

  /* era order or A to Z */
  $$('[data-ac-sort]').forEach(function (b, _, all) {
    b.addEventListener('click', function () {
      var az = b.getAttribute('data-ac-sort') === 'az';
      all.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      root.classList.toggle('is-az', az);
      var sorted = items.slice().sort(function (a, c) { return a.getAttribute('data-ac-az').localeCompare(c.getAttribute('data-ac-az')); });
      items.forEach(function (it) { it.style.order = az ? String(sorted.indexOf(it) + 1) : ''; });
      groups.forEach(function (g) { g.style.order = ''; });
    });
  });

  /* a link straight to an entry always shows it */
  function reveal() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var t = document.getElementById(id);
    if (t && t.hidden) {
      if (q) q.value = ''; term = ''; filter = 'all';
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-ac-f') === 'all' ? 'true' : 'false'); });
      apply();
      setTimeout(function () { t.scrollIntoView(); }, 30);
    }
  }
  window.addEventListener('hashchange', reveal);

  /* sticky bar sits under the site header */
  var hdr = document.querySelector('.sg-hdr-sec') || document.querySelector('header');
  function setTop() {
    var y = 0;
    if (hdr) { var r = hdr.getBoundingClientRect(); y = Math.max(0, Math.round(r.bottom)); }
    root.style.setProperty('--ac-top', y + 'px');
  }

  /* contents rail follows the reader, the timeline fills as you read */
  var fill = root.querySelector('[data-ac-fill]');
  var tl = root.querySelector('[data-ac-tl]');
  function spy() {
    var line = (parseFloat(getComputedStyle(root).getPropertyValue('--ac-top')) || 0) + 140;
    var cur = '';
    rail.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('data-for'));
      if (t && !t.hidden && t.getBoundingClientRect().top <= line) cur = a.getAttribute('data-for');
    });
    rail.forEach(function (a) { a.classList.toggle('on', a.getAttribute('data-for') === cur); });
    if (fill && tl) {
      var r = tl.getBoundingClientRect();
      var h = Math.max(0, Math.min(r.height - 8, window.innerHeight * 0.55 - r.top));
      fill.style.height = h + 'px';
      $$('.ac-ms').forEach(function (m) { m.classList.toggle('seen', m.getBoundingClientRect().top < window.innerHeight * 0.55); });
    }
    if (top) top.classList.toggle('on', window.scrollY > window.innerHeight * 1.5);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { setTop(); spy(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', function () { setTop(); spy(); });
  if (top) { top.hidden = false; top.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }); }
  setTop(); apply(); reveal();
})();
